<template>
    <div>
        <!--header-->
        <header class="header">
            <nav class="navbar navbar-expand navbar-light navbar-tp">
                <a class="navbar-brand me-auto" href="index.html"><img src="../images/logo.png" class="logo"></a>
                <div class="navbar-collapse" id="navbarSupportedContent">
                    <ul class="navbar-nav ms-auto align-items-center">
                        <li class="nav-item p-0 pe-3"><a class="nav-link p-0" href="#">Admin Panel</a></li>
                        <li class="nav-item p-0"><a class="logout_btn" @click="logout" href="#">Logout</a></li>
                    </ul>
                </div>
            </nav>
        </header>
        <section class="main-flw-work pt-40 pb-40">
            <div class="container work_container">
            <div class="row">
                <div class="col-lg-12 mb-3">
                    <div class="d-flex flex-wrap align-items-center justify-content-between">
                        <div class="top-title d-flex align-items-center flex-wrap">
                            <h1 class="fs-32 pe-3 mb-2">Workforce Monitoring System</h1>
                            <button class="refresh_btn white_rfresh me-3 mb-2" @click="refresh"><i class="fa fa-refresh"></i> Refresh Date</button>
                        </div>
                        <div class="top-date d-flex align-items-center flex-wrap justify-content-lg-end">
                            <div class="serch_vew d-flex mb-2 me-1">
                                <span v-if="searchBy === 'jobStart'">
                                    <input type="date" class="form-control" id="startDate" v-model="startDate" :max="maxDate">
                                </span>
                                <span v-else>
                                    <input type="search" v-model="searchValue" class="form-control" placeholder="Search Here" @input="search($event, searchValue)">
                                </span>
                                <div class="dropdown custm_select">
                                    <a class="btn btn-secondary dropdown-toggle" href="#" role="button" id="dropdownMenuLink" data-bs-toggle="dropdown" aria-expanded="false">
                                        <span v-if="searchBy === 'jobStart'">Job Start</span><span v-else>{{searchBy}}</span>
                                    </a>
                                    <ul class="dropdown-menu" aria-labelledby="dropdownMenuLink">
                                        <li><a class="dropdown-item" @click="searchBy = 'Email'" href="#" value="email">Email</a></li>
                                        <li><a class="dropdown-item" @click="searchBy = 'ID'" href="#" value="id">ID</a></li>
                                        <li><a class="dropdown-item" disabled @click="searchBy = 'jobStart'" href="#" value="jobStart">Job Start</a></li>
                                    </ul>
                                </div>
                            </div>
                            <div class="date_view flw_data_view mb-2">
                                <div class="date_list position-relative">
                                    <input type="date" class="form-control" id="startDate" v-model="startDate" :max="maxDate">
                                    <span class="line_txt">-</span>
                                    <input type="date" class="form-control" id="endDate" v-model="endDate" :max="maxDate">
                                </div>
                                <button class="filter_btn" @click="filterData">Filter</button>
                                <!-- <div class="date_list position-relative">
                                    <input type="text" class="form-control" placeholder="Mon, Jun 14, 2021" id="startDate">
                                    <span class="line_txt">-</span>
                                    <input type="text" class="form-control" placeholder="Sun, Jun 20, 2021" id="endDate">
                                </div>
                                <button class="filter_btn">Filter</button> -->
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-12 mb-3">
                    <div class="work_flw_system">
                        <b-table :key="refreshTable" class="table datatable-cstm" hover :items="data1" :fields="columns1" :current-page="currentPage" :per-page="perPage" :filter="filter">
                                <template #cell(createdAt)="data">
                                    {{ data.item.createdAt | changeDate}}
                                </template>
                                <template #cell(updatedAt)="data">
                                    <span>
                                    {{ data.item.updatedAt | changeDate}}
                                    </span>
                                </template>
                                <template #cell(download)="data" style="text-align:center;">
                                    <span>
                                        <button type="button" @click="clickDownload(data)" class="btn btn-outline-dark" icon="plus"><i class="fa fa-download"></i></button>
                                    </span>
                                </template>
                            </b-table>
                            <div class="datatable-pagintion pt-4" style="padding-left: 3%;">
                           <div class="row">
                               <div class="col-md-3 text-center text-md-start"><p class="fs-16 show_page_txt">Showing 15 Records per Page</p></div>
                               <div class="col-md-4">
                                    <div class="pagination-container" v-if="total > limit">
                                        <Page :transfer="true" :page-size="limit" :total="total" :current="cpage" @on-change="handlePage" @on-page-size-change="handlePagesize" />
                                    </div>
                               </div>
                           </div>
                       </div>
                    </div>
                </div>
            </div>
            </div>
        </section>
    </div>
</template>

<script>
    import _ from 'lodash'
    import axios from 'axios'
    import Cookies from 'js-cookie'
    import joblisting from '../api/joblisting'
    import moment from 'moment'
    import createVideo from "../api/createVideo";

    const AWS = require("aws-sdk");

    AWS.config.update({
    accessKeyId: process.env.VUE_APP_ACCESSKEY, //process.env.accesskey,
    secretAccessKey: process.env.VUE_APP_SECRETKEY //process.env.secretkey
    });
    AWS.config.region = "ap-south-1";

    export default {
        name: 'JobListing',
        props: {},
        data () {
            return {
                searchBy: 'Email',
                searchValue: '',
                refreshTable: 0,
                currentPage: 1,
                perPage: 15,
                filter: null,
                startDate: moment(Date()).format('YYYY-MM-DD'),
                endDate: moment(Date()).format('YYYY-MM-DD'),
                maxDate: moment(Date()).format('YYYY-MM-DD'),
                oldData: [],
                data1: [],
                // total: this.data1.length,
                cpage: 1,
                total: 0,
                skip: 0,
                limit:15,
                setLoading: true,

                columns1: [
                    {
                        title: 'Email Id',
                        key: 'emailID'
                    },
                    {
                        title: 'Id',
                        key: '_id'
                    },
                    {
                        title: 'Job Start',
                        key: 'createdAt',
                        label: 'Job Start'
                    },
                    {
                        title: 'Job End',
                        key: 'updatedAt',
                        label: 'Job End'
                    },
                    // {
                    //     title: 'Job Attainability Rate(%)',
                    //     key: 'percentage'
                    // },
                    {
                        title: 'Frames',
                        key: 'frames'
                    },
                    {
                        title: 'Download',
                        key: 'download'
                    }
                ],
            }
        },
        methods: {
            search (e) {
                let unicode = e.keyCode ? e.keyCode : e.charCode;
                let params = {'$limit':this.limit, '$sort[createdAt]':-1}
                if (this.searchValue !== '') {
                    if (this.searchBy === 'Email') {
                        params.emailID = (this.searchValue + String.fromCharCode(unicode)).replace(/\0/g, '')
                    } else if (this.searchBy === 'ID') {
                        params.userId = (this.searchValue + String.fromCharCode(unicode)).replace(/\0/g, '')
                    } else {
                        params.userId = (this.searchValue + String.fromCharCode(unicode)).replace(/\0/g, '')
                    }
                }
                let self = this
                joblisting.get(params)
                .then(async function (res) {
                    res.data.data.map((item) => {
                        item.frames = item.frames !== undefined ? item.frames : 0;
                        return item
                    })
                    self.oldData = _.cloneDeep(params.$paginate !== undefined ? res.data : res.data.data)
                    self.data1 = params.$paginate !== undefined ? res.data : res.data.data
                    self.total = res.data.total
                    self.setLoading = false
                    self.refreshTable ++
                })
                .catch(function (error) {
                    console.log(error);
                    self.setLoading = false
                });
            },
            async filterData () {
                let self = this
                let temp = []
                self.data1 = _.cloneDeep(this.oldData)
                if (this.startDate !== '' && this.endDate !== '') {
                    await _.filter(self.data1, (item, key) => {
                    if (new Date(this.startDate) <= new Date(item.createdAt) && new Date(this.endDate) >= new Date(item.createdAt)) {
                        temp.push(item)
                    }
                    })
                    self.data1 = _.cloneDeep(temp)
                }
            },
            clickDownload (data) {
                this.is_file(data.item.userId, data.item._id)
            },
            handlePage (page) {
                this.setLoading = true
                this.cpage = page
                this.skip = (page * this.limit) - this.limit
                // this.getSessionList()
                this.refresh();
            },

            handlePagesize (size) {
                this.setLoading = true
                this.limit = size
                this.skip = 0
                // this.getSessionList()
                this.refresh();
            },

            async logout() {

            Cookies.remove("auth_token");
            this.$router.push({
                name: "login"
            });
            },

            // // get page date
            // getPageList(p, size) {
            //     return this.data1.slice((p - 1) * size, p * size)
            // },

            // changePage(p) {
            //     this.page = p
            //     this.list = this.getPageList(p, this.pageSize)
            //     // this.table_data = this.getPageList(p, this.pageSize)
            // },

            is_file(userId, jobId){
                let self = this
                let filename = userId+"_"+jobId
                let file_path = "frames/"+userId+"/"+jobId+"/"+filename+".mp4"
                var s3 = new AWS.S3();
                s3.getObject(
                { Bucket: "customer-frames", Key: file_path },
                function (error, data) {
                    if (error != null) {
                        let videoData = {
                            "userId" : userId,
                            "jobId"  : jobId
                        }
                        // alert("Failed to retrieve an object: " + error);
                        let headers = {
                            "Content-Type": "application/json",
                        };
                        createVideo
                            .post(videoData, headers)
                            .then(function(response) {
                                self.download_file(userId, jobId)

                            })
                            .catch(function(error) {
                            console.log(error);
                            });
                    } 
                    else {
                        self.download_file(userId, jobId)
                    

                    }
                }
                );

            },
            download_file(userId, jobId){
                let filename = userId+"_"+jobId+".mp4"
                let file_path = "frames/"+userId+"/"+jobId+"/"+filename
                var s3 = new AWS.S3();
                s3.getObject(
                { Bucket: "customer-frames", Key: file_path },
                function (error, data) {
                    if (error != null) {
                    alert("Failed to retrieve an object: " + error);
                    } else {
                    let blob = new Blob([data.Body], { type: data.ContentType });
                    let link = document.createElement("a");
                    link.href = window.URL.createObjectURL(blob);
                    link.download = filename;
                    link.click();

                    }
                }
                );
            },
            refresh(){
                let self = this
                self.searchValue = ''
                self.searchBy = 'Email'
                let params = {'$skip':this.skip, '$limit':this.limit, '$sort[createdAt]':-1}
                joblisting.get(params)
                .then(async function (res) {
                    
                    // console.log(res.data.data)
                    res.data.data.map((item) => {
                        // console.log(typeof item.live_data)
                        // console.log(typeof item.non_live_data)
                        // let calculation = item.live_data/(item.live_data +item.non_live_data)
                        // let percentage = isNaN(calculation) ? 0 : calculation*100
                        // return item['percentage'] = Math.ceil(percentage)
                        // console.log(item.frames)
                        item.frames = item.frames !== undefined ? item.frames : 0;
                        // console.log(item.frames)
                        return item
                    })
                    // console.log("Data:", res.data.data.percentage)
                    // self.data1 = res.data.data
                    self.oldData = _.cloneDeep(params.$paginate !== undefined ? res.data : res.data.data)
                    self.data1 = params.$paginate !== undefined ? res.data : res.data.data
                    self.total = res.data.total
                    self.setLoading = false

                    // console.log(self.data1);
                    // self.total = self.data1.length;
                    // console.log(self.total)
                    
                })
                .catch(function (error) {
                    console.log(error);
                    self.setLoading = false
                });
            },



        },
        // beforeMount (){
        //     this.refresh()
        // },
        mounted () {
            let self = this
            self.refresh()
            // console.log(self.data1);
            
        },
        filters: {
            changeDate(val) {
                return moment(val).format('DD/MM/YYYY h:mm:ss a')
            }
        },
        feathers: {
            jobs: {
            created(data) {
                console.log("====Created Data==:", data);
                // self.data1 = data;
            },
            updated(data) {
                console.log("====updated==", data);
                // self.data1 = data;
                // if (self.data1.some(item => item.updatedAt === undefined)) {
                //   self.isClicked = false;
                //   self.id = self.data1[0]._id;
                //   // console.log(self.id)
                // } else {
                //   self.isClicked = true;
                // }
            },
            removed(data) {
                console.log("====removed==", data);
                // self.data1 = data;
            }
            }
        }
    }
</script>
